import { render } from "./arrowComponent.vue?vue&type=template&id=13fd2f52"
import script from "./arrowComponent.vue?vue&type=script&lang=js"
export * from "./arrowComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__